module.exports = __webpack_public_path__ + "img/logo-Santillana.853aec17.png";